export function createTitle(texts: string[]) {
  return ['Bumo', ...texts].join(' | ');
}
